import styled from "styled-components";

import Slider from "../components/ui/Slider";

const Container = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;

const ParamControls = ({ paramStates, min, max }) => {
  const [{ ns, setNs }, { tf, setTf }, { xvn, setXvn }] = paramStates;

  const slidersProps = [
    {
      className: "slider-xvn",
      nameLeft: "Extraverted",
      nameRight: "Introverted",
      colorLeft: "#B0BEC5",
      colorRight: "#78909C",
      value: xvn,
      setValue: setXvn,
      min: min + 0.05,
      max: max - 0.05,
      step: 0.01,
    },
    {
      className: "slider-ns",
      nameLeft: "Intuition",
      nameRight: "Sensing",
      colorLeft: "#66BB6A",
      colorRight: "#FFB74D",
      value: ns,
      setValue: setNs,
      min: min + 0.05,
      max: max - 0.05,
      step: 0.01,
    },
    {
      className: "slider-tf",
      nameLeft: "Thinking",
      nameRight: "Feeling",
      colorLeft: "#039BE5",
      colorRight: "#F06292",
      value: tf,
      setValue: setTf,
      min,
      max,
      step: 0.01,
    },
  ];

  return (
    <Container>
      {slidersProps.map((s) => (
        <Slider {...s}></Slider>
      ))}
    </Container>
  );
};

export default ParamControls;
